module.exports = __webpack_public_path__ + "img/logo.cba5a0f5.svg";